export default __webpack_public_path__ + "static/media/smart-chain-full.23363634.png";